import { type ContentLocale, toContentLocale } from "@/i18n/config";

/** The iOS app's App Store id; also what the Smart App Banner meta names. */
export const APP_STORE_ID = "1458122175";

/** The Android app's Play package name. */
export const PLAY_PACKAGE_NAME = "com.whoppah";

/**
 * App Store storefront per site locale (WHO-5649). Every locale we publish
 * maps to the country whose storefront carries that language; `en` has no
 * country of its own, so it lands on the Dutch storefront, our largest
 * market. Prices and availability shown in the store follow the storefront,
 * which is why a fixed `gb` link was wrong for every visitor.
 */
const APP_STORE_STOREFRONTS: Record<ContentLocale, string> = {
  en: "nl",
  nl: "nl",
  de: "de",
  fr: "fr",
  es: "es",
  it: "it",
};

/** The App Store listing on the storefront matching `locale` (a router locale). */
export const getAppStoreLink = (locale?: string) =>
  `https://apps.apple.com/${
    APP_STORE_STOREFRONTS[toContentLocale(locale)]
  }/app/whoppah/id${APP_STORE_ID}`;

/** The Play listing in the language of `locale` (a router locale). */
export const getPlayStoreLink = (locale?: string) =>
  `https://play.google.com/store/apps/details?id=${PLAY_PACKAGE_NAME}&hl=${toContentLocale(
    locale
  )}`;
